import React, { createRef, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import DividerWithText from '../components/Utils/Divider';
import {
  StyledText,
  StyledTextSubTitle,
  StyledTextTitleZ,
} from '../components/Utils/TextStyles';
import { red } from '@material-ui/core/colors';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  MenuItem,
  Select,
  Slide,
  TextField,
  Typography,
  styled,
} from '@material-ui/core';
import {
  getData,
  getListaInvitados,
  mensajeOk,
  updateAsistencia,
} from '../api';
import ReCAPTCHA from 'react-google-recaptcha';
import { useEffect } from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import EventIcon from '@material-ui/icons/Event';

function Alert(props) {
  return <MuiAlert elevation={6} variant='filled' {...props} />;
}

/* eslint-disable no-console */
const StyledTextField = styled(TextField)({
  '& label': {
    color: '#bb823f',
  },
  '&:hover label': {
    fontWeight: 700,
  },
  '& label.Mui-focused': {
    color: '#bb823f',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: '#006d46',
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: '#006d46',
    },
    '&:hover fieldset': {
      borderColor: '#006d46',
      borderWidth: 2,
    },
    '&.Mui-focused fieldset': {
      borderColor: '#006d46',
    },
  },
});

const useStyles = makeStyles(theme => ({
  root: {
    maxWidth: '100%',
    backgroundColor: 'red',
    minHeight: '90vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  container: {
    textAlign: 'center',
    position: 'relative',
    zIndex: '2',
  },
  image: {
    position: 'absolute',
    right: '15%',
    top: 0,
    width: '30%',
    maxWidth: '200px',
    opacity: '0.4',
  },
}));
const captcha = createRef();
const MENSAJE_CAPTCHA = 'Por favor acepta el captcha!';
const MENSAJE_CAMPOS = 'Ingresa tú número celular!';
const MENSAJE_NO_SE_ENCONTRO =
  'el número celular no sé encontró, favor de validarlo';
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

export default function About() {
  const classes = useStyles();
  const [captchaValido, cambiarCaptchaValido] = useState(null);
  const [usuarioValido, cambiarUsuarioValido] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [asistente, setAsistente] = useState(false);
  const [mensaje, setMensaje] = useState(MENSAJE_CAPTCHA);
  const captchaToken = process.env.REACT_APP_CAPTCHA;
  const [listaAsistentes, setListaAsistentes] = useState([]);
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [severity, setSeverity] = useState('success');
  const [mensajeSnackBar, setMensajeSnackBar] = useState(mensajeOk);

  async function ValidarCodigo(codigo) {
    const response = await getData(codigo);
    if (!response) {
      setMensaje(MENSAJE_NO_SE_ENCONTRO);
      cambiarCaptchaValido(false);
    }
    setAsistente(response);
    setOpenDialog(true);
  }
  useEffect(() => {
    if (asistente.id) {
      BusquedaCodigo();
    }
  }, [asistente]);

  async function BusquedaCodigo() {
    const { id } = asistente;
    const tmpLista = await getListaInvitados(id);
    tmpLista.push(asistente);
    setListaAsistentes(tmpLista);
    captcha.current.reset();
  }

  const onChange = () => {
    if (captcha.current.getValue()) {
      cambiarCaptchaValido(true);
    }
  };

  const submit = e => {
    e.preventDefault();
    if (captcha.current.getValue()) {
      cambiarUsuarioValido(true);
      cambiarCaptchaValido(true);
      const { codigo } = e.target;
      if (codigo.value.trim() === '') {
        setMensaje(MENSAJE_CAMPOS);
        cambiarCaptchaValido(false);
      } else {
        cambiarCaptchaValido(true);
        ValidarCodigo(codigo.value);
      }
    } else {
      setMensaje(MENSAJE_CAPTCHA);
      cambiarUsuarioValido(false);
      cambiarCaptchaValido(false);
    }
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setAsistente(false);
    setListaAsistentes([]);
    document.getElementById('invitacion-form').reset();
  };

  const handleClose = () => {
    setOpenSnackBar(false);
  };

  const handleSave = async () => {
    const response = await updateAsistencia(listaAsistentes);
    setMensajeSnackBar(response);
    setSeverity(response === mensajeOk ? 'success' : 'error');
    setOpenSnackBar(true);
    handleCloseDialog();
  };

  const updateFieldChanged = index => e => {
    let newArr = [...listaAsistentes];
    if (e.target.name === 'boletosConfirmados') {
      // console.log(
      //   parseInt(newArr[index].boletos),
      //   parseInt(e.target.value),
      //   parseInt(newArr[index].boletos) >= parseInt(e.target.value)
      // );
      if (parseInt(newArr[index].boletos) >= parseInt(e.target.value)) {
        newArr[index].boletosconfirmados = e.target.value;
      } else {
        newArr[index].boletosconfirmados = newArr[index].boletos;
      }
    } else if (e.target.name === 'kidsConfirmados') {
      if (parseInt(newArr[index].kids) >= parseInt(e.target.value)) {
        newArr[index].kidsconfirmados = e.target.value;
      } else {
        newArr[index].boletosconfirmados = newArr[index].kids;
      }
    }
    setListaAsistentes(newArr);
  };

  return (
    <div id='confirmar-asistencia'>
      <DividerWithText>B&U</DividerWithText>
      <div
        className={classes.container}
        // style={{
        //   backgroundRepeat: 'no-repeat',
        //   backgroundPosition: 'right',
        //   backgroundSize: 'auto',
        //   backgroundImage: `url(${
        //     process.env.PUBLIC_URL + '/assets/ByU-10.png'
        //   })`,
        // }}
      >
        <img
          src={process.env.PUBLIC_URL + '/assets/ByU-11.png'}
          className={classes.image}
        />
        <StyledText color={'#bb823f'}>Confirmar asistencia</StyledText>
        <div>
          <StyledTextSubTitle color={'#00774f'} style={{ textAlign: 'center' }}>
            Tu presencia es muy importante para nosotros, por favor ayúdanos con
            tu confirmación.
          </StyledTextSubTitle>
        </div>
        <form
          className='formulario'
          action=''
          onSubmit={submit}
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            flexDirection: 'column',
            alignContent: 'center',
            padding: 5,
          }}
          id='invitacion-form'
        >
          <StyledTextField
            id='codigo'
            label='Número celular'
            variant='outlined'
            style={{
              margin: 5,
            }}
          />
          {/* <StyledTextField
            id='nombre'
            label='Primer Nombre'
            variant='outlined'
            style={{
              margin: 5,
            }}
          /> */}
          <ReCAPTCHA
            ref={captcha}
            sitekey={captchaToken}
            onChange={onChange}
            style={{
              margin: 5,
              marginTop: 20,
            }}
          />
          <Button
            className='lblButton'
            type='submit'
            style={{
              borderRadius: 40,
              backgroundColor: '#006d46',
              fontSize: '18px',
              marginTop: 15,
              color: '#e2e1e1',
            }}
          >
            Buscar
          </Button>
        </form>

        <div style={{ marginTop: 20 }}>
          <DividerWithText>B&U</DividerWithText>
          <StyledText color={'#bb823f'}>Agregar a calendario</StyledText>
          <EventIcon
            fontSize='large'
            style={{ marginTop: 20, color: '#006d46', cursor: 'pointer' }}
            onClick={() =>
              window.open('https://calendar.app.google/QGK9EWL8mLE1kqAEA')
            }
          />
        </div>
      </div>
      {captchaValido === false && (
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            flexDirection: 'column',
            alignContent: 'center',
            padding: 5,
            color: 'red',
          }}
        >
          <span
            style={{
              maxWidth: '50%',
            }}
          >
            {mensaje}
          </span>
        </div>
      )}
      <div style={{ height: 50 }}></div>
      {asistente && asistente.nombre ? (
        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          maxWidth={'lg'}
          scroll={'paper'}
          TransitionComponent={Transition}
          disableEscapeKeyDown
          PaperProps={{
            style: {
              backgroundColor: '#e2e1e1',
            },
          }}
        >
          <DialogTitle id='confirmacion'>
            <StyledTextSubTitle color={'#006d46'}>
              {`Hola! ${asistente.nombre} ${asistente.apellidopaterno}, eres invitado especial de ${asistente.invitadode}`}
            </StyledTextSubTitle>
          </DialogTitle>
          <DialogContent dividers={'paper'}>
            <DialogContentText
              id='confirmacion-dialog-description'
              tabIndex={-1}
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'space-around',
              }}
            >
              <StyledTextSubTitle color={'#006d46'}>
                {`Te pedimos confirmar asistencia, ya que el cupo es limitado y recuerda que el boleto es `}
              </StyledTextSubTitle>
              <StyledTextSubTitle color={'#bb823f'}>
                &nbsp;PERSONAL
              </StyledTextSubTitle>
            </DialogContentText>
            {asistente ? (
              <div style={{ backgroundColor: '#e2e1e1' }}>
                <Grid container spacing={3}>
                  <Grid item xs>
                    <StyledTextSubTitle color={'#bb823f'}>
                      Nombre
                    </StyledTextSubTitle>
                  </Grid>
                  <Grid item xs>
                    <StyledTextSubTitle color={'#bb823f'}>
                      Boletos disponibles
                    </StyledTextSubTitle>
                  </Grid>
                </Grid>
                {listaAsistentes.map((asistenteItem, index) => (
                  <>
                    {asistenteItem.boletos > 0 ? (
                      <div
                        key={asistenteItem.codigo + index}
                        style={{ display: 'flex', alignItems: 'center' }}
                      >
                        <Grid
                          container
                          spacing={3}
                          style={{ display: 'flex', alignItems: 'center' }}
                        >
                          <Grid item xs>
                            <StyledTextSubTitle color={'#006d46'}>
                              {`${asistenteItem.nombre} ${asistenteItem.apellidopaterno}`}
                            </StyledTextSubTitle>
                          </Grid>
                          <Grid item xs>
                            <StyledTextSubTitle color={'#006d46'}>
                              <Select
                                id='cantidad'
                                name='boletosConfirmados'
                                label={'Cantidad'}
                                defaultValue={asistenteItem.boletosconfirmados}
                                onChange={updateFieldChanged(index)}
                              >
                                {[...Array(asistenteItem.boletos + 1)].map(
                                  (x, i) =>
                                    i === 0 ? (
                                      <MenuItem
                                        value={i}
                                        key={asistenteItem.nombre + i}
                                      >
                                        No podré asistir
                                      </MenuItem>
                                    ) : (
                                      <MenuItem
                                        value={i}
                                        key={asistenteItem.nombre + i}
                                      >
                                        {i}
                                      </MenuItem>
                                    )
                                )}
                              </Select>
                            </StyledTextSubTitle>
                          </Grid>
                        </Grid>
                      </div>
                    ) : null}
                    {asistenteItem.kids > 0 ? (
                      <div
                        key={asistenteItem.codigo + 'kids' + index}
                        style={{ display: 'flex', alignItems: 'center' }}
                      >
                        <Grid
                          container
                          spacing={3}
                          style={{ display: 'flex', alignItems: 'center' }}
                        >
                          <Grid item xs>
                            <StyledTextSubTitle color={'#006d46'}>
                              Niños
                            </StyledTextSubTitle>
                          </Grid>
                          <Grid item xs>
                            <StyledTextSubTitle color={'#006d46'}>
                              <Select
                                id='cantidad'
                                label={'Cantidad'}
                                name='kidsConfirmados'
                                defaultValue={asistenteItem.kidsconfirmados}
                                onChange={updateFieldChanged(index)}
                              >
                                {[...Array(asistenteItem.kids + 1)].map(
                                  (x, i) => (
                                    <MenuItem
                                      value={i}
                                      key={asistenteItem.nombre + i + 'kids'}
                                    >
                                      {i}
                                    </MenuItem>
                                  )
                                )}
                              </Select>
                            </StyledTextSubTitle>
                          </Grid>
                        </Grid>
                      </div>
                    ) : null}
                  </>
                ))}
              </div>
            ) : null}
          </DialogContent>
          <DialogActions
            style={{ display: 'flex', justifyContent: 'space-between' }}
          >
            <Button
              className='lblButton'
              onClick={handleCloseDialog}
              style={{
                borderRadius: 40,
                backgroundColor: red[900],
                fontSize: '18px',
                marginTop: 15,
                color: '#e2e1e1',
              }}
            >
              Cancelar
            </Button>
            <Button
              className='lblButton'
              onClick={handleSave}
              style={{
                borderRadius: 40,
                backgroundColor: '#006d46',
                fontSize: '18px',
                marginTop: 15,
                color: '#e2e1e1',
              }}
            >
              Guardar
            </Button>
          </DialogActions>
        </Dialog>
      ) : null}
      <Snackbar
        open={openSnackBar}
        autoHideDuration={6000}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity={severity}>
          {mensajeSnackBar}
        </Alert>
      </Snackbar>
    </div>
  );
}
